import { useSearchParams } from 'react-router-dom';
import { getStatusTitle } from '../../../orders/table-cell/orderCellService';
import {
  OrderView,
  resolveOrderView,
} from '../../../orders/order-views/orderViews';

export interface OrderViewState {
  view: OrderView;
  isLocked: boolean;
  /** OrderStatusEnum string values locked by the active view; [] when none. */
  lockedStatuses: string[];
  /** Locked statuses paired with their display labels for chips/popovers. */
  lockedOptions: { value: string; label: string }[];
}

export const useOrderView = (): OrderViewState => {
  const [params] = useSearchParams();
  const view = resolveOrderView(params.get('view'));
  const lockedStatuses = view.lockedStatuses ?? [];
  return {
    view,
    isLocked: view.lockedStatuses != null,
    lockedStatuses,
    lockedOptions: lockedStatuses.map((value) => ({
      value,
      label: getStatusTitle(value),
    })),
  };
};
